import { createSelector } from 'reselect';

import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';

import prop from 'lodash/fp/prop';
import map from 'lodash/fp/map';
import pipe from 'lodash/fp/pipe';
import orderBy from 'lodash/fp/orderBy';
import some from 'lodash/fp/some';

let mapfp = map.convert({ cap: false }); // set index on second argument in map

const getOwner = (userId, ranking) =>
  userId === (isObject(ranking.owner) ? ranking.owner._id : ranking.owner);

const setOwner = (userId) => (ranking) => ({
  ...ranking,
  isOwner: getOwner(userId, ranking),
});

const enrichRanking = (userId) => (ranking) => {
  const withPartner = {
    ...ranking,
    isPartnerGroup: ranking.isPartnerGroup === true,
  };
  return userId == null || userId === '' ? withPartner : setOwner(userId)(withPartner);
};

const withParticipants = (iteratee) => (ranking) => ({
  ...ranking,
  participants: iteratee(ranking.participants),
});

export const selectMyRankings = createSelector(
  [prop('rankings'), prop('user')],
  (rankings, user) =>
    isEmpty(user) ? rankings.map((r) => enrichRanking(null)(r)) : map(enrichRanking(user._id))(rankings)
);

export const selectRankingDetails = createSelector(
  [prop('rankingDetails'), prop('user')],
  (ranking, user) =>
    pipe(
      (ranking) => enrichRanking(isEmpty(user) ? null : user._id)(ranking),
      (ranking) => ({
        ...ranking,
        participants: map(
          (p) => (getOwner(p._id, ranking) ? { ...p, isOwner: true } : p),
          ranking.participants
        ),
      }),
      withParticipants(orderBy(['score', 'username'], ['desc', 'asc'])),
      withParticipants(
        mapfp((p, i) => ({ ...p, rank: i + 1, me: p._id === user._id }))
      ),
      withParticipants(orderBy(['rank'], ['asc']))
    )(ranking)
);

///// Global Ranking

const sameUserId = (a, b) =>
  a != null && b != null && String(a) === String(b);

const setUserinList = (list, user) =>
  list.map((usr) => ({ ...usr, me: sameUserId(usr.userId, user._id) }));

export const selectGlobalRankingTop = createSelector(
  [prop('globalRanking.top'), prop('user')],
  (top, user) => (!isEmpty(user) ? setUserinList(top, user) : top)
);

export const isUserInTop = createSelector(
  selectGlobalRankingTop,
  some({ me: true })
);

export const selectMyRange = createSelector(
  [prop('globalRanking.myRange'), prop('user')],
  setUserinList
);
